// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"30":"b6dc7ad0","494":"e751bbb4","584":"7d13c614","778":"50e5b0b3"}[chunkId] + ".chunk.css";
};